// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chartWrapper[data-v-160b8a98]{position:relative;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;-webkit-align-content:center;justify-content:center;-ms-flex-line-pack:center;align-content:center}.current-price[data-v-160b8a98]{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
